module.exports = __webpack_public_path__ + "img/slider-1.20de4117.png";